<template>
  <div v-if="tmpProduct" class="option-row" :class="{ 'option-row--active': selected }">
    <div class="option-main" @click="toggle">
      <div class="option-label">{{ tmpProduct.nombre }}</div>
      <div v-if="selected && $parent.llevaCantidad" class="qty-pill" @click.stop>
        <v-btn icon x-small :disabled="permitirRestar" @click="updateProducto(-1)">
          <v-icon small>mdi-minus</v-icon>
        </v-btn>
        <span class="qty-value">{{ tmpCant }}</span>
        <v-btn icon x-small :disabled="permitirAgregar" @click="updateProducto(1)">
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
    <v-checkbox
      v-model="selected"
      :disabled="deshabilitarCheck"
      color="primary"
      hide-details
      class="ma-0 pa-0 option-check"
      @click.stop
    />
  </div>
</template>

<script>
export default {
  name: 'CombinadoCard',
  computed: {
    permitirRestar () {
      if (this.llevaPrecioMitad && this.producto.esSeleccion) {
        return this.tmpCant <= 0.5
      }
      return this.tmpCant <= 1
    },
    permitirAgregar () {
      return this.$parent.cantidadTotal >= this.$parent.cantidadMinima
    },
    deshabilitarCheck () {
      if (this.$parent.llevaCantidad) return this.$parent.cantidadTotal >= this.$parent.cantidadMinima && !this.selected
      else return false
    }
  },
  mounted () {
    this.tmpProduct = { ...this.producto }
    if (this.llevaPrecioMitad && this.producto.esSeleccion) {
      this.tmpCant = 0.5
    } else {
      this.tmpCant = 1
    }
  },
  data () {
    return {
      selected: false,
      tmpProduct: null,
      tmpCant: null
    }
  },
  methods: {
    toggle () {
      if (this.deshabilitarCheck && !this.selected) return
      this.selected = !this.selected
    },
    updateProducto (cant) {
      if (this.llevaPrecioMitad && this.producto.esSeleccion) {
        this.tmpCant += (cant * 0.5)
        if (this.tmpCant < 0.5) {
          this.tmpCant = 0.5
        }
      } else {
        this.tmpCant += cant
        if (this.tmpCant < 1) {
          this.tmpCant = 1
        }
      }
      this.tmpProduct.cant = this.tmpCant
      this.$emit('update-product', this.tmpProduct)
    }
  },
  props: {
    producto: {
      type: Object
    },
    llevaPrecioMitad: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    selected (newValue) {
      if (this.llevaPrecioMitad && this.producto.esSeleccion) {
        this.tmpCant = 0.5
      } else {
        this.tmpCant = 1
      }
      if (!newValue) {
        this.$emit('remove-product', this.tmpProduct)
      } else {
        this.updateProducto(0)
      }
    }
  }
}
</script>
<style scoped>
.option-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}
.option-row:last-child {
  border-bottom: none;
}
.option-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
}
.option-label {
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.3;
  word-break: break-word;
}
.option-row--active .option-label {
  font-weight: 600;
}
.option-check {
  flex: 0 0 auto;
  margin-right: -8px !important;
}
.qty-pill {
  display: flex;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  padding: 0 2px;
  min-width: 88px;
  justify-content: space-between;
  flex-shrink: 0;
}
.qty-value {
  font-weight: 700;
  min-width: 20px;
  text-align: center;
  font-size: 0.85rem;
}
</style>
